import React, { Component } from 'react'
import Utils from '../lib/utils'
/**
 * 导航搜索框
 */
const cfg = {
  js: '//static.youku.com/v2.0.5/soku/giantstar/js/sk-box-open.js',
  boxConfig: {
    'site': 14,
    css: '//static.youku.com/v2.0.4/soku/giantstar/css/s_kubox.css'
  }
}
class HeaderSearch extends Component {
  componentDidMount () {
    if (typeof window !== 'undefined') {
      // window.addEventListener('scroll', this.headerScroll.bind(this));
      Utils.getScript(cfg.js, () => {
        window.XBox.init(cfg.boxConfig)
      })
    }
  }
  searchHandle (e) {
    const form = document.getElementById('qheader_search')
    const input = form.getElementsByTagName('input')[0]
    e.preventDefault()
    if (!form) {
      return
    }
    let q = input.value || ''; let url = ''; let spm = ''
    q = q.replace(/^\s*$/g, '')
    spm = window.g_SPM && window.g_SPM.spm(form)
    if (q === '') {
      url = '//www.soku.com'
    } else {
      q = encodeURIComponent(q)
      url = `//so.youku.com/search_video/q_${q}?spm=${spm}`
    }
    window.open(url)
    return false
  }
  render () {
    // onSubmit=" if(typeof(XBox) == 'object'){  return false;  }else if(typeof(ykQHeader) == 'object'){ return ykQHeader.doSearch(); }
    return (
      <div className='g-so' data-spm='search'>
        <div className='g-so-box'>
          <form id='qheader_search' action='//so.youku.com/search_video/q_' onSubmit={this.searchHandle} method='get' target='_blank' >
            <input name='q' id='headq' type='text' autoComplete='off' />
            <button type='submit' data-spm='dbutton' onClick={this.searchHandle}>搜全网</button>
            <div id='qheader_keywords' style={{ display: 'none' }}>
              <a target='_blank' href='//www.soku.com/search_video/q_' className='' />
            </div>
            <input type='text' style={{ display: 'none' }} />
          </form>
        </div>
      </div>
    )
  }
}
export default HeaderSearch
